// extracted by mini-css-extract-plugin
export default {"pageContainer":"companySecurity_pageContainer__1yhdD","headerContainer":"companySecurity_headerContainer__O1Tl2"};